module.exports = __webpack_public_path__ + "img/role-story-teller.ef644c68.png";